import styled from '@emotion/styled';
import {
    rem,
    Card
} from '@triumph/design-system';

export const PaddedCard = styled(Card)<{ isLarge: boolean }>`
    padding: 0 ${({ isLarge }: any) => (isLarge ? `${rem(24)}` : `${rem(15)}`)}
        ${rem(12)};
    border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
    border-radius: ${rem(4)};
    box-shadow: none;
    position: relative;
    flex: 1;
`;